//  dark or light theme
import { createContext, useContext } from "react";

export type ThemeMode = "light" | "dark" | "kd";

export interface ThemeContextType {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode, storePreference: boolean) => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useThemeMode = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeMode must be used within a ThemeProvider");
  }
  return context.theme;
};

export const useSetTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useSetTheme must be used within a ThemeProvider");
  }
  return context.setTheme;
};
